import React, { Component } from "react";
import FixedView from "../FixedView";
import { nanoid } from "nanoid";
import { FormBuilderObjects, TypeToInputType } from "../../variables/formBuilderData";
import inputComponents from "./inputComponents";
import { checkTranslation, translate } from "../../utils/useful";
import StagesManager from "../StagesManager";
import EmptyInput from "./EmptyInput";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../stores/actionsList';


class HubConditionFilterItems extends React.Component {
    state = {
        items: [],
        // LI: [],
        data: {
            root: {
                id: 'root',
                action: 'and',
                conditions: {}
            }
        },
        // tempData: {},
        // columns: [],


        inputHeader: {
            type: 'TextInput'
        },
        // condition: [
        //     { item: 'contains' },
        //     { item: 'does not contain' },
        //     { item: 'is' },
        //     { item: 'is not' },
        //     { item: 'is empty' },
        //     { item: 'is not empty' }
        // ],
        slectedCell: [],
        // operatorItems: [
        //     { title: 'Equal', value: 'Equal' },
        //     { title: 'Less Than', value: 'Less Than' },
        //     { title: 'More Than', value: 'More Than' },
        //     { title: 'Equal of less than', value: 'Equal of less than' },
        //     { title: 'Equal of more than', value: 'Equal of more than' },
        //     { title: 'Contains', value: 'Contains' },
        // ],
        // andOR: [],
        search: "",
        sourceItems: [],
        sourceType: [],

        // validOperatorItems:
    }
    componentDidUpdate(prevProps) {
        // this.setState({ items: this.props.items }, () => {
        // })
        if ((prevProps.items != this.props.items) || (prevProps.optionsList != this.props.optionsList)) {
            this.init()
        };
    }

    componentDidMount() {
        let current = { level: 0, groupId: 'root', parents: [] }

        if (this.props.data) {
            this.setState({ data: this.props.data })
        } else {
            this.setState({ current }, () => {
                // this.doAdd('con', current)
            })
        }
        let items = this.props.items ?? this.props.optionsList
        this.setState({ items: items }, () => {
            // this.setState({ sourceItems: this.state.items, source: this.props.prop.source, target: this.props.prop.target, operator: this.props.prop.operator })
        });
        this.init()

    }

    init() {
        // console.log("INIT",this.props.items)
        let items = this.props.items ?? this.props.optionsList
        this.setState({ items: items }, () => {
            this.setState({ sourceItems: this.state.items, source: this.props.prop.source, target: this.props.prop.target, operator: this.props.prop.operator })
        })
        let element
        if (typeof items == 'object') {
            for (let i = 0; i < Object.values(items).length; i++) {
                element = Object.values(items)[i];
                this.setState({ slectedCell: element }, () => {
                })
            }
        }
        else {

            for (let i = 0; i < items?.length; i++) {
                element = items[i];


                this.setState({ slectedCell: element }, () => {
                })
            }
        }
    }



    openFirstView = () => {
        // this.props.setCurrent('current',{})
        // let current = { groupId: this.props.data.id, id: this.props.prop.id, key: 'source', parents: this.props.parents }
        // if (this.props.setCurrent) {
        //     this.props.setCurrent('current', current)
        // }
        this.sourceFixedView.showView();
    };
    openSecondView = () => {
        // let current = { groupId: this.props.data.id, id: this.props.prop.id, key: 'action', parents: this.props.parents }
        // if (this.props.setCurrent) {
        //     this.props.setCurrent('current', current)
        // }
        this.actionFixedView.showView();
    };
    openoperatoresFixedView = () => {

        this.operatoresFixedView.showView();
    };

    // saveAction = () => {
    //     this.saveSidebar.open()
    // }

    // doDone = () => {
    //     this.setState({ tempData: -1 }, () => {
    //         this.props.changeValue(this.props.header?.key, this.props.data, this.props.extra)
    //     })
    // }

    // openAdd = (id, parents, level) => {
    //     this.setState({ currentNode: this['add-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.fixedView.showView()
    //     })
    // }

    // openActionsView = (id, parents, level) => {
    //     this.setState({ currentNode: this['action-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.actionsView.showView()
    //     })
    // }

    // doAdd = (type, current) => {
    //     if (this.fixedView) {
    //         this.fixedView.hideView()
    //     }
    //     let id = nanoid(10)

    //     let newCondition
    //     if (type == 'con') {
    //         newCondition = { id, source: null, operator: null, target: null }
    //     } else {
    //         newCondition = { id, action: 'and' }
    //     }
    //     let data = this.props.data
    //     // let current = this.state.current
    //     current.id = id


    //     this.actionOnChild(data, current, newCondition, 'add', 0)


    //     this.setState({ data: data })
    // }

    changeAction = (type, id) => {
        let data = this.props.data
        data.action = type
        // let current = this.state.current
        // this.actionOnChild(data, current, type, 'changeOperator', 0)
        this.setState({ data }, () => {
            // if (this.props?.changeValue) {
            //     this.props.changeValue('action', data.action, this.props.extra)
            // }
            // let current = { groupId: this.props.data.id, id: this.props.prop.id, key: 'action', parents: this.props.parents }
            // new Promise((resolve) => {

            //     if (this.props.setCurrent) {
            //         this.props.setCurrent('current', current, () => {
            //             resolve()
            //         })
            //     }
            //     else {
            //         resolve()
            //     }
            // }).then(() => {

            if (this.props.actionOnChild) {
                this.props.actionOnChild(data, this.props.current, type, 'changeOperator', 0)
            }
            this.actionFixedView.hideView()
            // })

        })
        if (this.actionsView) {
            this.actionsView.hideView()
        }
    }

    removeRow = (groupId, id, parents) => {
        let current = { groupId, id, parents }
        let data = this.props.data
        this.actionOnChild(data, current, null, 'remove', 0)
        this.setState({ data: data })

    }

    openInput = (key, id, groupId, parents) => {
        // let current = { groupId, id, parents, key }
        // let data = this.props.data
        // if (this.props.setCurrent) {

        //     this.props.setCurrent('current', current, () => {
        //         return

        //         let value = this.props.actionOnChild(data, this.props.current, null, 'get', 0)
        //         // this.props.changeInputValue('', data.conditions[id], this.props.extra)

        //         let inputHeader = {
        //             type: 'SmartInput'
        //             , information: {}
        //         }

        //         if (key == 'operator') {
        //             inputHeader = {
        //                 type: 'SelectInput', information: {
        //                     type: 'local', items: [
        //                         { title: '{{lang}}Equal', value: 'Equal' },
        //                         { title: '{{lang}}Less Than', value: 'Less Than' },
        //                         { title: '{{lang}}More Than', value: 'More Than' },
        //                         { title: '{{lang}}Equal or less than', value: 'Equal of less than' },
        //                         { title: '{{lang}}Equal or more than', value: 'Equal of more than' },
        //                         { title: '{{lang}}Contains', value: 'Contains' },
        //                     ]
        //                 }
        //             }
        //         }

        //         this.setState({ inputHeader, currentNode: this[key + '-' + id], current: { id, groupId, parents, key, value } }, () => {
        //             this.inputView?.showView()
        //         })
        //     })
        // }

    }

    // changeInputValue = (key, value) => {
    //     let current = this.state.current
    //     let data = this.props.data
    //     // let value = target.value

    //     this.actionOnChild(data, current, value, 'update', 0)
    //     current.value = value//target.value
    //     this.setState({ data, current })
    // }

    // actionOnChild(data, current, value, action, index) {

    //     if (index == current.parents.length) {

    //         if (action == 'add') {

    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             if (!data[current.groupId].conditions) {
    //                 data[current.groupId].conditions = {}
    //             }
    //             data[current.groupId].conditions[current.id] = value

    //         }

    //         if (action == 'remove') {
    //             if (current.id == null) {
    //                 delete data[current.groupId]
    //             } else {
    //                 delete data[current.groupId].conditions[current.id]
    //             }
    //         }

    //         if (action == 'changeOperator') {
    //             if (!data[current.groupId]) {
    //                 data[current.groupId] = {}
    //             }
    //             data[current.groupId].action = value
    //         }

    //         if (action == 'update') {
    //             data[current.groupId].conditions[current.id][current.key] = value
    //         }

    //         if (action == 'get') {
    //             return data[current.groupId].conditions[current.id][current.key]
    //         }

    //     } else if (index < current.parents.length) {
    //         let newData = data[current.parents[index]]
    //         if (newData) {
    //             return this.actionOnChild(newData.conditions, current, value, action, index + 1)
    //         }
    //     }
    // }

    // getLabel(prop, key) {
    //     let label = prop[key]
    //     let hasValue = true
    //     if (!label) {
    //         label = translate('Choose')
    //         hasValue = false
    //     }
    //     return { label, hasValue }
    // }

    // setData = (item) => {
    //     this.setState({ labela: item, selectedChoose: true, selectedCalc: true, calca: item })
    // }
    sourceSelectHandler = (item, baseKey, id, check, isFirstLevel) => {

        let sourceItems = this.state.sourceItems
        let sourceType = isFirstLevel ? [] : this.state.sourceType
        let key = typeof baseKey == 'object' ? (baseKey._id ?? baseKey.key) : baseKey

        // sourceType.push(key)
        if ((item?.type == "field" || item?.type == "FieldInput") && (!Array.isArray(item.fieldTypes) || item.fieldTypes.length != 1)) {

            this.props.actions.addNotif({ type: 'error', title: '{{lang}}Type error', description: "{{lang}}This type of field can have more than one data type, so it can not be used for logical condition. Use another variable or limit this field to only one data type." })
            return

        }

        // console.log(item, key, sourceType)

        this.setState({ source: key, operator: "", sourceItems, sourceType: sourceType }, () => {
            // if (this.props.headers || check) {
            if (!this.props.optionsList || check) {

                let data = this.props.data
                data.conditions[id].source = key
                data.conditions[id].operator = null

                let current = { groupId: this.props.data.id, id: this.props.prop.id, key: 'source', parents: this.props.parents, extra: { sourceType: this.state.sourceType } }
                new Promise((resolve) => {
                    if (this.props.setCurrent) {
                        this.props.setCurrent('current', current, () => {
                            resolve()
                        })
                    }
                    else {
                        resolve()
                    }
                }).then(() => {

                    if (this.props?.changeInputValue) {
                        this.props.changeInputValue("source", key, current, this.props.extra)

                        let type = ''
                        // TO DO: Check the logic
                        if (['diagramVariables', 'sharedVariables'].includes(current.extra.sourceType[0])) {
                            type = current.extra.sourceType[0]
                        } else {
                            type = 'collection'
                        }
                        const newCurrent = { ...current }
                        newCurrent.key = 'type'

                        // console.log(newCurrent)
                        this.props.changeInputValue("type", type, newCurrent, this.props.extra)


                    }
                    // this.setState({ data })
                    this.sourceFixedView.hideView()
                    this.operatoresFixedView.showView();
                })
                // this.props.changeInputValue
                // if (this.props?.changeValue) {
                //     this.props.changeValue(id, data.conditions[id], this.props.extra)
                // }

            }
            else {
                sourceType = []
                // let type = ['variables', 'systemVariable'].includes(key) ? key : 'collections'
                sourceType.push(key)
                this.setState({ sourceType: sourceType })
                this.stagesManager.changeStage('second')
            }
        })


    }
    // changeSourceSelectStage = () => {

    // }
    operatorSelectHandler = (item, id) => {
        let data = this.props.data
        data.conditions[id].operator = item.value
        // this.setState({ operator: item.value, data }, () => {
        // if (this.props?.changeValue) {
        //     this.props.changeValue(id, data.conditions[id], this.props.extra)
        // }
        let current = { groupId: this.props.data.id, id: this.props.prop.id, key: 'operator', parents: this.props.parents }
        // new Promise((resolve) => {

        //     if (this.props.setCurrent) {
        //         this.props.setCurrent('current', current, () => {
        //             resolve()
        //         })
        //     }
        //     else {
        //         resolve()
        //     }
        // }).then(() => {
        if (this.props?.changeInputValue) {
            this.props.changeInputValue("operator", item.value, current, this.props.extra)
            // this.props.changeInputValue('', data.conditions[id].operator, this.props.extra)
        }
        this.operatoresFixedView.hideView()
        if (this.componentInput?.focus) {
            this.componentInput.focus()
        }
        // })
        // })

    }
    searchInput = (e) => {
        this.setState({ search: e.target.value }, () => {
            this.filterHandler(e);
        })
    }
    filterHandler = () => {
        let temp = [];

        if (Array.isArray(this.state.items)) {
            let items = [...this.state.items];
            for (let i = 0; i < items.length; i++) {
                let content = items[i];
                if (content?.information?.label.toLowerCase().includes(this.state.search.toLowerCase())) {
                    temp.push(content);
                }
            }


        }
        else {
            let items = { ...this.state.items };
            for (let i = 0; i < Object.values(items)?.length; i++) {
                let content = Object.values(items)[i];
                if (content?.label.toLowerCase().includes(this.state.search.toLowerCase())) {
                    temp.push(content);
                }
            }

        }
        this.setState({ sourceItems: temp }, () => {
        });
    };

    changeTargetValue = (key, value, extra) => {
        let data = this.props.data
        data.conditions[extra.id].target = value



        // this.setState({ target: value, data }, () => {
        // let data = this.props.data
        // data.conditions[extra.id].target = value

        // if (this.props?.changeValue) {
        //     this.props.changeValue(extra.id, data.conditions[extra.id], this.props.extra)
        // }
        let current = { groupId: this.props.data.id, id: this.props.prop.id, key: 'target', parents: this.props.parents }
        // new Promise((resolve) => {

        //     if (this.props.setCurrent) {
        //         this.props.setCurrent('current', current, () => {
        //             resolve()
        //         })
        //     }
        //     else {
        //         resolve()
        //     }
        // }).then(() => {

        if (this.props?.changeInputValue) {

            this.props.changeInputValue("target", value, current, this.props.extra)

            // this.props.changeInputValue('', value, this.props.extra)
        }
        // })
        // })
    }



    setSourceAsObject = (item) => {

        let sourceType = this.state.sourceType
        let key = item.key

        sourceType.push(key)


        this.setState({ tempCurrentSourceObject: item, sourceType }, () => {
            this.stagesManager.changeStage('object')
        })
    }

    goToPreviousStage = () => {

        let sourceType = this.state.sourceType
        sourceType.pop()
        this.stagesManager.lastStage()
        this.setState({ sourceType })
    }



    render() {
        let sourceLabel
        let sourceType = 'HubConditionalFilterInput'
        let sourceHelperObject

        let validOperatorItems
        let sourceIcon
        let selectedField
        // console.log(this.props.prop.source)
        // console.log(this.state.sourceItems)

        validOperatorItems = FormBuilderObjects[sourceType]?.operators

        if (this.props.prop.source) {
            if (Array.isArray(this.state.sourceItems)) {


                this.state.sourceItems?.forEach((item) => {
                    if (item.key == this.props.prop.source) {
                        selectedField = JSON.parse(JSON.stringify(item))
                        selectedField.information.placeholder = '{{lang}}Value ...'
                        sourceLabel = item.information.label
                        sourceType = item.type
                        // console.log("sourceType",sourceType)
                        if (!FormBuilderObjects[sourceType]) {
                            sourceType = TypeToInputType[sourceType]
                        }
                        // validOperatorItems = FormBuilderObjects[sourceType]?.operators
                        sourceIcon = FormBuilderObjects[sourceType]?.icon

                        // console.log("TP1")
                    }
                })
            }
            else {
                if (this.state.sourceItems && typeof this.state.sourceItems == 'object') {
                    Object.values(this.state.sourceItems)?.forEach((item) => {
                        if (item.list) {

                            item.list.map((element) => {
                                if (element.key == this.props.prop.source || element.name == this.props.prop.source || element._id == this.props.prop.source) {
                                    sourceLabel = element.name ?? element?.information?.label
                                    sourceType = element.field ?? element.type

                                    if (Array.isArray(element.fieldTypes) && element.fieldTypes.length == 1) {
                                        sourceType = TypeToInputType[element.fieldTypes[0]]
                                    }

                                    selectedField = JSON.parse(JSON.stringify(element))

                                    if (!selectedField.information) {
                                        selectedField.information = {}
                                    }
                                    selectedField.information.placeholder = '{{lang}}Value ...'

                                    if (!FormBuilderObjects[sourceType]) {
                                        sourceType = TypeToInputType[sourceType]
                                    }
                                    // validOperatorItems = FormBuilderObjects[sourceType]?.operators
                                    sourceIcon = FormBuilderObjects[sourceType]?.icon

                                    // console.log("TP2",element)
                                }

                                if (!sourceType && this.props.prop.source.includes('.')) {


                                    let splitedKey = this.props.prop.source.split('.')
                                    // console.log("splitedKey",splitedKey)
                                    if (element.key == splitedKey[0] && Array.isArray(element.structure)) {

                                        splitedKey.splice(0, 1)
                                        let fieldKey = splitedKey.join('.')

                                        for (let m = 0; m < element.structure.length; m++) {
                                            const field = element.structure[m];
                                            // console.log("HERE!",fieldKey,field)

                                            if (field.key == fieldKey) {

                                                sourceLabel = field.name ?? field?.information?.label
                                                sourceType = field.field ?? field.type
                                                selectedField = JSON.parse(JSON.stringify(field))
                                                if (!selectedField.information) {
                                                    selectedField.information = {}
                                                }
                                                selectedField.information.placeholder = '{{lang}}Value ...'
                                                selectedField.information.disabled = false

                                                // console.log("HERE!!",selectedField)
                                                if (element.dynamicStructureFrames) {
                                                    selectedField.dynamicStructureFrames = element.dynamicStructureFrames
                                                }

                                                if (!FormBuilderObjects[sourceType]) {
                                                    sourceType = TypeToInputType[sourceType]
                                                }

                                                // validOperatorItems = FormBuilderObjects[sourceType]?.operators
                                                sourceIcon = FormBuilderObjects[sourceType]?.icon

                                                sourceHelperObject = element
                                            }
                                        }

                                    }
                                }
                            })
                        } else {

                            if (item.key == this.props.prop.source) {
                                // console.log("TP3")
                                sourceLabel = item.label
                                // sourceType = item.type
                                // validOperatorItems = FormBuilderObjects[sourceType].operators
                            }
                        }
                    })
                }

            }
        }


        // console.log(selectedField)

        let operatorLabel
        let targetType
        let targetHeader
        if (this.props.prop.operator) {
            validOperatorItems?.forEach((item) => {
                if (checkTranslation(item.value) == checkTranslation(this.props.prop.operator)) {
                    operatorLabel = item.title
                    targetType = item.type
                    targetHeader = item.valueInput ? JSON.parse(JSON.stringify(item.valueInput)) : null


                    // TO DO: MUST LATER CHECK IF COMBINATION OF targetHeader AND selectedField IS OK OR HAS ISSUE 

                    if (selectedField && selectedField.information) {

                        Object.entries(selectedField.information)?.map(([skey, svalue]) => {
                            if (targetHeader.information[skey] == null) {
                                targetHeader.information[skey] = svalue
                            }
                        })
                    }
                }
                // console.log(selectedField)

                if (targetHeader && selectedField?.dynamicStructureFrames) {
                    if (!targetHeader?.information) {
                        targetHeader.information = {}
                    }
                    targetHeader.information.frame = selectedField.dynamicStructureFrames
                }
            })
        }

        // console.log(targetHeader)
        let Component = null
        if (this.props.prop.operator) {
            Component = inputComponents[targetHeader?.type]
        }





        return (
            <>

                {this.props.index == 0 && (

                    <div className="flexc mb-1">
                        <div className={"flexc " + (this.props.conditionsLength > 1 ? '' : 'd-none')}>
                            <button ref={(el) => (this.secondCurrentNode = el)} onClick={() => this.openSecondView()} className="flexcb px-3" style={{ height: '30px', background: '#F5E8DD', color: '#000', gap: ".1em", border: '0px solid rgba(220, 220, 220, 0.8)', borderRadius: 20, marginRight: ".1rem" }}>
                                <span className="text-smaller text-semibold mrd-1" style={{}}>{this.props.data.action}</span>
                                <div className="flexcc " style={{ paddingTop: 2 }}>
                                    {this.props.index == 0 ?
                                        <img className="mld-1" style={{ opacity: 0.8 }} src="/assets/icons/down-arrow.svg" width="8px" alt="" />
                                        :
                                        <img className="mld-1" style={{ opacity: 0 }} src="/assets/icons/down-arrow.svg" width="8px" alt="" />
                                    }
                                </div>
                            </button>
                        </div>



                    </div>
                )}
                <div key={this.props.prop.id} className={"mb-1 flexcb"} style={{ width: "100%" }}  >

                    {/* <div className="flexcc" style={{ flex: '1 1 100%', gap: ".1em" }}> */}
                    <div className="flexc w-100" style={{}}>


                        {/* SOURCE */}
                        {/* <button ref={(el) => (this.firstCurrentNode = el)} onClick={() => this.openFirstView()} className="m-0  flexc" style={{ maxWidth: '40%', background: '#D2E9E9', color: '#000', border: '0px solid rgba(220, 220, 220, 0.8)', borderRadius: "20px" }}>
                            <div className="pld-2 prd-4 m-0 flexc w-100" style={{ color: '#000', }}>
                                <div className="flexc w-100" style={{}}>
                                    {sourceIcon && (
                                        <div>
                                            <div className="br-20 flexcc " style={{ backgroundColor: '#ffffffaa', height: 20, width: 20 }}>
                                                <img className="grayscale-filter " src={sourceIcon} height={14} />
                                            </div>
                                        </div>
                                    )}
                                    <p className="text-smaller text-start text-bold" style={{ padding: '7px 5px', color: !this.props.prop.source ? "#144a4a80" : "#144a4a", display: "inline-block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: sourceIcon ? 'calc(100% - 20px)' : '100%' }}>
                                        {(!this.props.prop.source) ? translate('Choose') : (sourceLabel ? checkTranslation(sourceLabel) : translate("Not valid!"))}
                                    </p>
                                </div>
                            </div>
                        </button> */}
                        {/* {console.log(this.props.prop)} */}
                        {/* OPERATOR */}
                        <button ref={(el) => (this.thirdCurrentNode = el)} onClick={() => { this.openoperatoresFixedView() }} className="m-0  mx-1 flexc" style={{ maxWidth: Component != EmptyInput ? '50%' : 'calc(50% - 30px)', background: '#D5F0C1', color: (!this.props.prop.operator) ? "#2b520e80" : "#2b520e", border: '0px solid rgba(220, 220, 220, 0.8)', borderRadius: "20px", }}>
                            <div className="px-2 m-0 flexc w-100" style={{ color: (!this.props.prop.operator) ? "#2b520e80" : "#2b520e", }}>
                                <p className="text-smaller text-start text-bold" style={{ color: !this.props.prop.operator && "#000", opacity: !this.props.prop.operator && ".3", padding: '7px 5px', display: "inline-block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: '100%' }}>
                                    {(this.props.prop?.operator) ? checkTranslation(operatorLabel) : translate('Operator')}
                                </p>
                            </div>
                        </button>


                        {/* TARGET */}
                        {/* <button ref={el => this['target-' + this.props.prop.id] = el} className="px-2 m-0  flexcc" onClick={() => { if (operatorLabel) this.openInput('target', this.props.prop.id, this.props.data.id, this.props.parents) }} style={{  flex: "1 1 0", maxWidth: 300, backgroundColor: "#fff", width: 0, border: '1px solid rgba(220, 220, 220, 0.8)', borderRadius: "5px", width: '100%', height: '30px' }}> */}
                        {Component != EmptyInput && (
                            <div ref={el => this['target-' + this.props.prop.id] = el} className="m-0  flexc" style={{ maxWidth: 'calc(50% - 30px)', backgroundColor: "#D2E9E9", border: '0px solid rgba(220, 220, 220, 0.8)', borderRadius: "20px", }}>
                                <div className=" m-0  flexc w-100" >

                                    {!Component && (
                                        <button className="text-smaller flexcc text-start text-bold" onClick={() => { if (operatorLabel) this.openInput('target', this.props.prop.id, this.props.data.id, this.props.parents) }} style={{ cursor: 'not-allowed', padding: '7px 10px', color: !Component ? "#10454580" : "#104545", whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                            <p style={{ color: '#10454580', display: "inline-block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: '100%', }}>{translate('Value ...')}</p>
                                        </button>
                                    )}
                                    {Component && (
                                        <div className="text-smaller flexcc text-start text-bold" style={{ padding: targetHeader?.padding ?? '7px 10px', color: !Component ? "#10454580" : "#104545", whiteSpace: 'nowrap', overflow: 'hidden' }}>
                                            <div className="filter-input flexcc " >


                                                <Component ref={(el) => this.componentInput = el} changeValue={this.changeTargetValue} data={this.props.prop.target} header={targetHeader} setStatus={this.setStatus} variables={this.props.variables} extra={{ id: this.props.prop.id }} tableCell={true} isConditionComponent={true} params={this.props.params} />
                                                {/* <Component ref={(el) => this.componentInput = el} changeValue={this.changeTargetValue} data={this.props.prop.target} header={selectedField} setStatus={this.setStatus} variables={this.props.variables} extra={{ id: this.props.prop.id }} tableCell={true} /> */}

                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        )}

                        {this.props.index > -1 ? (
                            <div className="grayscale-filter">
                                <button onClick={() => this.props.removeRow(this.props.data.id, this.props.prop.id, this.props.parents, this.props.level)} className="flexcc mld-2 mrd-2" style={{ height: 16, width: 16, borderRadius: "20px", border: '1px solid #FF3B30' }}>
                                    {/* <img className="" style={{ opacity: 1}} src="/assets/icons/applets/drive/trash.svg" width="11px" /> */}
                                    {/* <p>&times;</p> */}
                                    <p className="flexcc text-normal" style={{ color: "#FF3B30" }}>&times;</p>

                                </button>
                            </div>
                        ) : (
                            <div style={{ width: 26, height: 30 }}></div>
                        )}
                    </div>

                    <FixedView ref={(el) => (this.actionFixedView = el)} nodeRef={this.secondCurrentNode} topOffset={0} xOffset={-10} zIndex={10}>
                        <div className="flexcc flex-column py-2" style={{ backgroundColor: '#ffffff', boxShadow: '0px 0px 20px #10101040', borderRadius: 4, cursor: 'pointer', width: 150 }}>
                            {/* <p className="text-small tex-uppercase text-bold">Add New</p> */}
                            <div className="action py-1 w-100" style={{}} onClick={() => this.changeAction('and', this.props.prop.id)}>
                                <p className="text-small text-semibold px-2">{translate('and')}</p>
                                <p className="text-smallest color-gray-2 px-2">{translate('All conditions should be true to be applied')}</p>

                            </div>
                            <div className="action py-1 w-100" style={{}} onClick={() => this.changeAction('or', this.props.prop.id)}>
                                <p className="text-small text-semibold px-2">{translate('or')}</p>
                                <p className="text-smallest color-gray-2 px-2">{translate('If any of following conditions be true it will be applied')}</p>
                            </div>
                        </div>
                    </FixedView>


                    {/* SOURCE */}
                    <FixedView ref={(el) => (this.sourceFixedView = el)} nodeRef={this.firstCurrentNode} topOffset={-30} xOffset={-10} zIndex={10} maxWidth={200} width={200} >
                        <div className="flex-column w-100" style={{ marginTop: 30, backgroundColor: '#ffffff', boxShadow: '0px 0px 20px #10101040', borderRadius: 8, width: '160px' }}>
                            <StagesManager height={'100%'} ref={e => this.stagesManager = e} fast={true}>
                                <div stage={0} stageName='main' className="h-100 scroll-no-scrollbar " style={{ minHeight: 35, maxHeight: 200 }}>
                                    <div className="fields-search flexc p-1 w-100 top-0 " style={{ zIndex: 1, background: "#fff", borderBottom: '1px solid #eee', overflow: 'hidden', position: 'sticky', borderTopRightRadius: 7, borderTopLeftRadius: 7 }}>
                                        <img src="/assets/icons/gantt/search.svg" className="mld-1" />
                                        <input type="search" name="name" className="fields-search text-smaller p-1 w-100 text-semibold " style={{ borderBottom: 'none', }} placeholder={translate("Search ...")} value={this.state.search} onChange={(e) => this.searchInput(e)} />
                                    </div>
                                    <div className="pb-2 pt-2 w-100 h-100" style={{ flex: 1, borderRadius: 4, position: 'relative', }}>
                                        {/* <Component optionsList={this.props.optionsList} header={this.state.inputHeader} data={this.state.current?.value ? this.state.current?.value : ''} changeValue={this.changeInputValue} /> */}
                                        {Array.isArray(this.state.sourceItems) ? (
                                            <>
                                                {
                                                    this.state.sourceItems?.map((item, index) => {

                                                        return (
                                                            <div key={index} className="flexc p-1 px-2 mb-1 grayscale-filter action w-100" style={{ cursor: "pointer" }} onClick={() => this.sourceSelectHandler(item, item, this.props.prop.id, null, true)}>
                                                                <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                                    <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[item.type]?.icon} width="18px" />
                                                                </div>
                                                                <p className="text-small text-semibold">{checkTranslation(item?.information?.label)}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    this.state.sourceItems && Object.values(this.state.sourceItems)?.map((item, index) => {
                                                        return (
                                                            <button key={index} className="p-1 px-2 my-1 w-100 text-start" onClick={() => this.sourceSelectHandler(item, item.key, this.props.prop.id, null, true)}>
                                                                <div key={index} className="flexcb " >
                                                                    <div className="flexc">
                                                                        <p className="text-small text-semibold">{checkTranslation(item?.label)}</p>
                                                                    </div>
                                                                    <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />

                                                                </div>

                                                                <p className="text-smaller color-gray-2">{item.list?.length} items</p>

                                                            </button>
                                                        )
                                                    })
                                                }

                                            </>
                                        )}
                                    </div>
                                </div>

                                <div stage={1} stageName='second' className="mt-2" style={{ minHeight: '100px' }}>
                                    {this.state.sourceItems && this.state.sourceItems[this.state.source]?.list?.length != 0 ? (
                                        <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                                            <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                                                <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                                    <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} alt="" />
                                                </button>
                                                <p className="text-small text-semibold">{(checkTranslation(this.state.sourceItems[this.state.source]?.label))}</p>
                                            </div>
                                            <div className="pt-1">
                                                {this.state.sourceItems && this.state.sourceItems[this.state.source]?.list?.map((element) => {
                                                    let name = element.name ?? element?.information?.label
                                                    let key = element._id ?? element.key
                                                    let type = (element.dataType ?? element.type)?.toLowerCase()
                                                    let isObject = false


                                                    if (type == 'field' || type == 'FieldInput') {
                                                        if (Array.isArray(element.fieldTypes) && element.fieldTypes.length == 1) {
                                                            type = element.fieldTypes[0]
                                                        }
                                                    }


                                                    if (type) {
                                                        type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                                                    }
                                                    if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                                                        isObject = true
                                                    }


                                                    // if(element)
                                                    return (
                                                        // <div className="flexc p-1 my-1 " style={{ cursor: 'pointer' }} onClick={() => this.sourceSelectHandler(key, this.props.prop.id, true)}>
                                                        //     <p className="text-smaller">{checkTranslation(name)}</p>
                                                        // </div>
                                                        <button key={key} className="flexcb p-1 px-2 mb-1 grayscale-filter  w-100 text-start" onClick={() => isObject ? this.setSourceAsObject(element) : this.sourceSelectHandler(element, key, this.props.prop.id, true)}>
                                                            <div className="flexc">
                                                                <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                                    <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" alt="" />
                                                                </div>
                                                                <p className="font-size-13 text-semibold">{checkTranslation(name)}</p>
                                                            </div>
                                                            {isObject && (
                                                                <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                            )}
                                                        </button>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="w-100 px-2 py-2">
                                            <div className="bb-gray w-100 flexc mb-2">
                                                <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                                    <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} alt="" />
                                                </button>
                                                {this.state.sourceItems && (
                                                    <p className="text-smaller main-c2">{(this.state.sourceItems[this.state.source])?.label?.length > 20 ? (this.state.sourceItems[this.state.source])?.label?.substring(0, 20) + '...' : (this.state.sourceItems[this.state.source])?.label}</p>
                                                )}
                                            </div>
                                            <p className="text-smaller">{translate("Not found")}</p>
                                        </div>
                                    )}
                                </div>



                                <div stage={1} stageName='object' className="mt-2" style={{ minHeight: '100px' }}>
                                    {this.state.tempCurrentSourceObject && this.state.tempCurrentSourceObject?.structure?.length != 0 && (
                                        <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                                            <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                                                <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                                    <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} />
                                                </button>
                                                <p className="text-small text-semibold">{(checkTranslation(this.state.tempCurrentSourceObject?.name))}</p>
                                            </div>

                                            <div className="pt-1">

                                                {(this.state.tempCurrentSourceObject?.structure == null || this.state.tempCurrentSourceObject?.structure?.length == 0) && (
                                                    <div className="flexcc py-2">
                                                        <p className="text-smaller text-semibold">{translate("Found nothing")}</p>
                                                    </div>
                                                )}

                                                {this.state.tempCurrentSourceObject?.structure?.map((element) => {
                                                    let name = element.name ?? element?.information?.label
                                                    let key = element._id ?? element.key
                                                    key = this.state.tempCurrentSourceObject?.key + '.' + key
                                                    let type = (element.dataType ?? element.type)?.toLowerCase()
                                                    let isObject = false
                                                    if (type) {
                                                        type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                                                    }
                                                    // console.log(type)
                                                    if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                                                        isObject = true
                                                    }

                                                    return (

                                                        <button key={key} className="flexcb p-1 px-2 mb-1 grayscale-filter  w-100" onClick={() => isObject ? this.setSourceAsObject(element) : this.sourceSelectHandler(element, key, this.props.prop.id, true)}>
                                                            <div className="flexc">
                                                                <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                                    <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" />
                                                                </div>
                                                                <p className="text-small text-semibold">{checkTranslation(name)}</p>
                                                            </div>
                                                            {isObject && (
                                                                <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                            )}
                                                        </button>
                                                    )
                                                })}

                                            </div>
                                        </div>
                                    )}
                                </div>
                            </StagesManager>
                        </div>
                    </FixedView>




                    <FixedView ref={(el) => (this.operatoresFixedView = el)} nodeRef={this.thirdCurrentNode} topOffset={0} xOffset={-10} zIndex={10} bottomOffset={20}>
                        <div className="flex-column" style={{ marginTop: 0, backgroundColor: '#ffffff', boxShadow: '0px 0px 20px #10101040', borderRadius: 8, width: '160px' }}>
                            <div className="fields-search flexc p-1 px-2 top-0 w-100" style={{ borderBottom: '1px solid #eee', overflow: 'hidden', borderTopRightRadius: 7, borderTopLeftRadius: 7, }}>
                                <img src="/assets/icons/gantt/search.svg" className="mld-1" />
                                <input type="search" name="name" className="fields-search text-smaller p-1 w-100 text-semibold" style={{ borderBottom: 'none', }} placeholder={translate("Search ...")} value={this.state.secondSearch} onChange={(e) => this.secondSearch(e)} />
                            </div>
                            <div className="scroll-no-scrollbar w-100" style={{ border: 'none', flex: 1, borderRadius: 4, position: 'relative', maxHeight: 200 }}>
                                {/* <Component optionsList={this.props.optionsList} header={this.state.inputHeader} data={this.state.current?.value ? this.state.current?.value : ''} changeValue={this.changeInputValue} /> */}

                                {validOperatorItems?.map((item, index) => {
                                    return (
                                        <div key={index} className="flexc px-3 py-2 action w-100" style={{ cursor: "pointer" }} onClick={() => this.operatorSelectHandler(item, this.props.prop.id)}>
                                            {/* <img className="mx-1" style={{ opacity: 0.8 }} src={item.src} width="10px" /> */}
                                            <p className="text-smaller text-semibold">{checkTranslation(item.title)}</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </FixedView>


                </div >
            </>

        )
    }
}
// export default HubConditionFilterItems;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(HubConditionFilterItems);